import React from "react";
import SeccionTablaAsistenciaDiaria from "./SeccionTablaAsistenciaDiaria";
import StatsCards from "./StatsCards";
import Activities from "./Activities";
import styled from "styled-components";
import { useUsuarioActual } from "../../../services/authServicios";
import { tieneRol } from "../../../services/rolAutorizacion";

const StyledDashboardContent = styled("div")`
  padding: 10px 20px 0px 20px;
  position: relative;
  width: 100%;
`;

function DashboardContent() {
  const { data: usuario } = useUsuarioActual();
  const puedeVerMascotas = tieneRol(usuario?.roles ?? [], "PROPIETARIOS_MASCOTAS");
  const puedeVerAsistencia = tieneRol(usuario?.roles ?? [], "CHECK_IN");
  const puedeVerVentas = tieneRol(usuario?.roles ?? [], "LISTAR_HISTORIAL_VENTAS");
  const puedeVerActividades = tieneRol(usuario?.roles ?? [], "ADMINISTRAR_USUARIOS");

  return (
    <StyledDashboardContent className="main-content">
      <StatsCards
        puedeVerMascotas={puedeVerMascotas}
        puedeVerAsistencia={puedeVerAsistencia}
        puedeVerVentas={puedeVerVentas}
      />
      <div className="row">
        {puedeVerAsistencia && <SeccionTablaAsistenciaDiaria />}
        {puedeVerActividades && <Activities />}
      </div>
    </StyledDashboardContent>
  );
}

export default DashboardContent;
